'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FavoritesIndicator = function FavoritesIndicator(_ref) {
  var favorited = _ref.favorited,
      showText = _ref.showText;

  var getFavoritesIndicatorClasses = function getFavoritesIndicatorClasses() {
    return (0, _classnames2.default)({
      'quiver-favorites-indicator': true,
      'quiver-favorites-indicator--favorited': favorited,
      'quiver-favorites-indicator--show-text': showText,
      'quiver-favorites-indicator--show-text--favorited': showText && favorited
    });
  };

  return _react2.default.createElement(
    'div',
    { className: getFavoritesIndicatorClasses() },
    _react2.default.createElement(
      'svg',
      { className: 'quiver-favorites-indicator__icon' },
      _react2.default.createElement(
        'g',
        null,
        _react2.default.createElement('circle', { cx: '16', cy: '16', r: '16' }),
        _react2.default.createElement('polygon', {
          points: '16 8, 18.5 13, 24 14, 20 18, 21 23, 16 20, 11 23, 12 18, 8 14, 13.5 13',
          strokeLinejoin: 'round'
        })
      )
    ),
    showText ? _react2.default.createElement(
      'div',
      { className: 'quiver-favorites-indicator__text' },
      favorited ? 'Favorited' : 'Add Favorite'
    ) : null
  );
};

FavoritesIndicator.propTypes = {
  favorited: _propTypes2.default.bool,
  showText: _propTypes2.default.bool
};

FavoritesIndicator.defaultProps = {
  favorited: false,
  showText: false
};

exports.default = FavoritesIndicator;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/FavoritesIndicator/FavoritesIndicator.js
// module id = 578
// module chunks = 11